import { Pipe, PipeTransform } from '@angular/core';
import { ClientesService } from '../../services/clientes.service';

@Pipe({
    name: 'propiedadCliente' // nombre del pipe en las directivas
})

export class PropiedadClientePipe implements PipeTransform {

    constructor(public clientesService:ClientesService){}

    // Métdodo a implementar siempre
    transform(idCliente:string, propiedad:string):any{
        return this.clientesService.obtenerPropiedadCliente(idCliente, propiedad).valueChanges().take(1);
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/propiedad-cliente.pipe.ts